import React from "react";
import ExcelImportPage from "./ExcelImportPage";

const ImportRepresentation = () => (
  <ExcelImportPage
    title="درون‌ریزی وکالت‌نامه از اکسل"
    endpoint="/import-representation/"
    description="فایل وکالت‌نامه‌ها را انتخاب کنید. پس از بارگذاری، نتیجه در همین صفحه نمایش داده می‌شود."
  />
);

export default ImportRepresentation;
